import {
  DASHBOARD_LINK,
  DASHBOARD_SETTINGS_LINK,
} from '@components/Router/constants'
import type { ID } from '@octopus-do/octopus-project-core'
import { Button } from '@octopus-do/octopus-storybook'
import { selectIsLoading } from '@store/loaders'
import { getTeamWorkspace } from '@store/reducers/dashboard/selectors'
import { closeModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import type { AppState } from '@/types'

interface Props {
  title: string
}

export const TeamSetupButton: React.FC<Props> = ({ title }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const userId = useSelector<AppState, ID>(({ auth }) => auth.id)
  const team = useSelector(getTeamWorkspace(userId))
  // The workspace list is still on its way in right after the upgrade.
  const loading = useSelector(selectIsLoading('workspaces'))

  const waiting = !team && loading

  const handleClick = () => {
    navigate(team ? `${DASHBOARD_SETTINGS_LINK}/${team.id}` : DASHBOARD_LINK)
    dispatch(closeModal())
  }

  return (
    <Button
      priority="secondary"
      label={title}
      loading={waiting}
      onClick={handleClick}
    />
  )
}
